import { ContentCategory } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/CreateContentModal/Types'
import { BrandPlanTactic, ContentCountType, PostPromptType } from 'types'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { TACTIC_TO_PROVIDER } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/SelectAccountsModal/SelectAccountsModal'
import {
  EMAIL_TACTICS,
  SEO_TACTICS,
  SOCIAL_MEDIA_TACTICS,
  STORY_TACTICS,
  VIDEO_TACTICS,
} from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/BrandPlanTactics'

export type ContentCategoryKey =
  | 'post:still_image'
  | 'post:carousel'
  | 'post:video'
  | 'short'
  | 'story'
  | 'newsletter'
  | 'blog_post'

export const CONTENT_CATEGORY_KEY_TO_CONTENT_CATEGORY: Record<ContentCategoryKey, ContentCategory> = {
  'post:still_image': 'still_image_post',
  'post:carousel': 'carousel_post',
  'post:video': 'feed_video_post',
  short: 'short_form_video',
  story: 'stories',
  newsletter: 'newsletter',
  blog_post: 'blog_post',
}

export const CONTENT_CATEGORY_TO_CONTENT_CATEGORY_KEY: Record<ContentCategory, ContentCategoryKey> = {
  still_image_post: 'post:still_image',
  carousel_post: 'post:carousel',
  feed_video_post: 'post:video',
  short_form_video: 'short',
  stories: 'story',
  newsletter: 'newsletter',
  blog_post: 'blog_post',
}

export const POST_TYPE_TO_TACTIC: Record<PostPromptType, BrandPlanTactic | null> = {
  instagram_post: BrandPlanTactic.Instagram,
  instagram_reel: BrandPlanTactic.InstagramReel,
  instagram_story: BrandPlanTactic.Instagram,
  facebook_post: BrandPlanTactic.Facebook,
  facebook_story: BrandPlanTactic.Facebook,
  linkedin_post: BrandPlanTactic.LinkedIn,
  twitter_post: BrandPlanTactic.Twitter,
  twitter_thread: BrandPlanTactic.Twitter,
  tiktok_post: BrandPlanTactic.TikTok,
  youtube_short: BrandPlanTactic.YouTube,
  blog_post: BrandPlanTactic.SEO,
  newsletter: BrandPlanTactic.Email,
  google_my_business_post: BrandPlanTactic.GoogleBusinessProfile,
}

export const CONTENT_COUNT_TYPE_MAP: Record<PostPromptType, ContentCountType> = {
  instagram_post: 'post',
  instagram_reel: 'short',
  instagram_story: 'story',
  facebook_post: 'post',
  facebook_story: 'story',
  linkedin_post: 'post',
  twitter_post: 'post',
  twitter_thread: 'thread',
  google_my_business_post: 'post',
  tiktok_post: 'short',
  youtube_short: 'short',
  blog_post: 'blog_post',
  newsletter: 'newsletter',
}

export const getCategoryTactics = (type: string): BrandPlanTactic[] => {
  const contentCountType = CONTENT_COUNT_TYPE_MAP[type as PostPromptType]
  switch (contentCountType) {
    case 'short':
    case 'reel':
      return [...VIDEO_TACTICS]
    case 'story':
      return [...STORY_TACTICS]
    case 'blog_post':
      return [...SEO_TACTICS]
    case 'newsletter':
      return [...EMAIL_TACTICS]
    case 'post':
    case 'thread':
      return [...SOCIAL_MEDIA_TACTICS]
    default:
      return []
  }
}

export const getDefaultAccountIds = (
  type: string,
  effectiveTactics: BrandPlanTactic[],
  integrations: ExternalIntegration[],
  isCrosspost = false,
): number[] | null => {
  if (isCrosspost) {
    const ids = effectiveTactics.flatMap((tactic) => {
      const provider = TACTIC_TO_PROVIDER[tactic]
      if (!provider) return []
      return integrations.filter((i) => i.provider === provider).map((i) => i.id)
    })
    return ids.length > 0 ? ids : null
  }
  const tactic = POST_TYPE_TO_TACTIC[type as PostPromptType]
  if (!tactic || !effectiveTactics.includes(tactic)) return null
  const provider = TACTIC_TO_PROVIDER[tactic]
  if (!provider) return null
  const ids = integrations.filter((i) => i.provider === provider).map((i) => i.id)
  return ids.length > 0 ? ids : null
}
